<template>
  <div>
    <!-- <v-row>
      <v-col cols="12" md="12" class="pa-2">
        <GraphInscriptionsPerHour :id_module="mainStore.module.id"></GraphInscriptionsPerHour>
      </v-col>
    </v-row> -->


    <v-row>
      <v-col cols="12" md="6" class="pa-2">
        <ListCoursesOverview :id_module="mainStore.module.id"></ListCoursesOverview>
      </v-col>
      <v-col cols="12" md="6" class="pa-2">
        <GraphInscriptionsPerWeek :id_module="mainStore.module.id"></GraphInscriptionsPerWeek>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import GraphInscriptionsPerWeek from "./GraphInscriptionsPerWeek.vue";

import ListCoursesOverview from "./ListCoursesOverview.vue";

export default {
  components: { GraphInscriptionsPerWeek, ListCoursesOverview },
  data() {
    return {
      historique: null,
      selected_edition_id: null

    }
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>